import React, { Component } from "react";
import {
    Panel,
    Modal,
    Button,
    OverlayTrigger,
    Tooltip,
    Table,
    Form,
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    ProgressBar
}                           from "react-bootstrap";
import {
    ToastContainer,
    toast
}                           from "react-toastify";
import                           "react-toastify/dist/ReactToastify.css";
import Pagination           from "react-js-pagination";
import axios from "axios";
import moment from "moment";

import FormContainer        from "./FormContainer";
import saveTrail            from '../../utils/saveTrail';
import socketIOClient     from "socket.io-client";
import FileSaver            from "file-saver";

import {
    IS_NULL,
    IS_VALID,
    GENERATE_RANDOM
}                           from "utils";

const SERVER_URL = window.__APP_CONFIG__.SERVER_URL
const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class Kumulos extends Component {
    constructor (props) {
        super(props);

        this.exportComponentRef = React.createRef();

        this.state = {
            showModalExport: false    
        };

        this.getData = this.getData.bind(this);
        this.handlePaginate = this.handlePaginate.bind(this);
        this.renderModalButton = this.renderModalButton.bind(this);
        this.accessible = this.accessible.bind(this);
    }

    getData (page = 1) {
        let {
            Kumulos,
            actions
        } = this.props;

        let {
            limit
        } = Kumulos;

        actions.setValue({
            isLoading: true,
            activePage: page
        });

        axios({
            method: "get",
            url: "https://crm.kumulos.com/v2/users?",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            params: {
                currentPage: page,
                numberPerPage: limit
            },
            auth: {
                username: "580f4320-6854-4770-a03e-e9a1ed830fc4",
                password: "udTYmwB0VF/gXfVHi3ifLqDsCEU0pViagcD+"
            }
        })
        .then((res) => {
            let {
                users,
                totalUsers
            } = res.data;

            actions.setValue({
                isLoading: false,
                data: users,
                count: totalUsers
            });
        })
        .catch((err) => {
            console.log("getData error");
            console.log(err);

            actions.setValue({
                isLoading: false,
                data: [],
                count: 0
            });
        });
    }

    handlePaginate (page) {
        let {
            activePage
        } = this.props.Kumulos;

        if (activePage !== page) {
            this.getData(page);
        }
    }

    renderModalButton () {
        let {
            Kumulos,
            actions
        } = this.props;

        let {
            isLoadingAction,
            formType
        } = Kumulos;

        let buttons = [],
            buttonAction = (
                name = "CREATE",
                loading = isLoadingAction,
                callback = this.saveData
            ) => (
                <Button
                    bsStyle="primary"
                    disabled={loading}
                    onClick={() => callback()}
                >
                    {name}
                </Button>
            ),
            buttonClose = (
                <Button
                    disabled={isLoadingAction}
                    onClick={() => {
                        if (!isLoadingAction) {
                            actions.setValue({
                                showModal: false
                            });
                        }
                    }}
                >
                    CLOSE
                </Button>
            );

        switch (formType.toUpperCase()) {
            default:
                buttons.push(
                    buttonClose
                );
                break;
        }

        return buttons;
    }

    accessible(actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

    render () {
        let {
            showModalExport
        } = this.state;

        let {
            Kumulos,
            accessjson,
            actions
        } = this.props;


        let {
            showModal,
            isLoadingAction,

            selectedData,
            formType,
            formTitle,

            isLoading,
            isExporting,
            data,
            count,
            activePage,
            limit
        } = Kumulos;

        let formContainerProps = {
            actions
        };

        let paginationProps = {
            activePage: activePage,
            itemsCountPerPage: limit,
            totalItemsCount: count,
            pageRangeDisplayed: 5,
            onChange: this.handlePaginate
        };

        let style_th = {
            whiteSpace: "nowrap"
        };

        return (
            <div>
                <Panel>
                    <Panel.Heading style={{
                        backgroundColor: '#D1282F',
                        color: 'white'
                    }}>
                        <h4>Kumulos</h4>
                    </Panel.Heading>
                    <Panel.Body>
                        <div>
                            <Button
                                className="btn-primary"
                                style={{ display: this.accessible('EXPORT') }}
                                onClick={() => {
                                    if (this.accessible('EXPORT') === '') {
                                        this.setState({
                                            showModalExport: true
                                        });
                                    }
                                }}
                            >
                                EXPORT
                            </Button>
                            <br/>
                            <br/>
                            <Table hover responsive>
                                <thead>
                                    <tr>
                                        <th style={style_th}>MEMBER ID</th>
                                        <th style={style_th}>CARD TYPE</th>
                                        <th style={style_th}>NAME</th>
                                        <th style={style_th}>DOB</th>
                                        <th style={style_th}>DAD</th>
                                        <th style={style_th}>CREATED AT</th>
                                        <th style={style_th}>UPDATED AT</th>
                                        <th>ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading && (
                                        <tr>
                                            <td
                                                colSpan={10}
                                                style={{
                                                    textAlign: 'center',
                                                    color: '#808080'
                                                }}
                                            >
                                                <i className="fa fa-spinner fa-spin fa-3x"></i>
                                            </td>
                                        </tr>
                                    )}
                                    {!isLoading && data.length === 0 && (
                                        <tr>
                                            <td
                                                colSpan={15}
                                                style={{
                                                    textAlign: 'center',
                                                    color: '#808080'
                                                }}
                                            >
                                                No Data Available
                                            </td>
                                        </tr>
                                    )}
                                    {!isLoading && data.map((item, index) => {
                                        let {
                                            identifier,
                                            attributes,
                                            createdAt,
                                            updatedAt
                                        } = item;

                                        attributes = attributes || {};

                                        let memberId = attributes["MMID"],
                                            cardType = attributes["Card Type"],
                                            name = attributes["First Name"],
                                            dob = attributes["DOB"],
                                            dad = attributes["Date Added"];

                                        return (
                                            <tr key={index}>
                                                <td>{memberId}</td>
                                                <td>{cardType}</td>
                                                <td>{name}</td>
                                                <td>{dob}</td>
                                                <td>{dad}</td>
                                                <td>{moment(createdAt).format("MMM DD, YYYY hh:mm A")}</td>
                                                <td>{moment(updatedAt).format("MMM DD, YYYY hh:mm A")}</td>
                                                <td>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip id="tooltip">View</Tooltip>
                                                        }
                                                    >
                                                         <a
                                                            className="fa fa-eye fa-lg"
                                                            href="javascript:void(0)"
                                                            onClick={() => {
                                                                if (this.accessible('VIEW') === "") {
                                                                    actions.setValue({
                                                                        showModal: true,
                                                                        selectedData: item,
                                                                        formType: "VIEW",
                                                                        formId: identifier,
                                                                        formTitle: "VIEW"
                                                                    });
                                                                }
                                                            }}
                                                            style={{ display: this.accessible('VIEW') }}
                                                        />
                                                    </OverlayTrigger>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            <div>Total Records: {count}</div>
                            <Pagination {...paginationProps}/>
                        </div>
                    </Panel.Body>
                </Panel>
                <Modal
                    bsSize={null}
                    show={showModal}
                    onHide={() => {
                        if (!isLoadingAction) {
                            actions.setValue({
                                showModal: false
                            });
                        }
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormContainer {...formContainerProps}/>
                    </Modal.Body>
                    <Modal.Footer>
                        {this.renderModalButton()}
                    </Modal.Footer>
                </Modal>
                <Modal
                    bsSize={null}
                    backdrop="static"
                    show={showModalExport}
                    onHide={() => {
                        if (
                            this.exportComponentRef.current &&
                            this.exportComponentRef.current.isLoading()
                        ) {
                            return;   
                        }
                        
                        this.setState({
                            showModalExport: false
                        });
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>EXPORT KUMULOS</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ExportComponent
                            ref={this.exportComponentRef}
                            count={count}
                            closeModal={() => {
                                this.setState({ showModalExport: false });
                            }}
                        />
                    </Modal.Body>
                </Modal>
                <ToastContainer />
            </div>
        );
    }

    componentDidMount () {
        this.getData();
    }
}

class ExportComponent extends Component {
    constructor (props) {
      super(props);
    
      this.state = {
        password: "",
        skipNumberOfRecord: "",
        numberOfRecord: "",
  
        isExportStarting: false,
        isExporting: false,
        isExportSuccess: false,
        isExportError: false,
        exportPercentage: 0,
        fileConfig: {
            filename: "",
            blob: ""
        },
        errorMessage: ""
      };
  
      this.exportData = this.exportData.bind(this);
      this.downloadFile = this.downloadFile.bind(this);
      this.isLoading = this.isLoading.bind(this);
    }
  
    exportData () {
      let {
        password,
        skipNumberOfRecord,
        numberOfRecord
      } = this.state;

      let {
          count
      } = this.props;
      
      if (
        Number(skipNumberOfRecord) < 0
      ) {
        toast.error("Skip Number of record should be greater than 0.");
      } else if (
        Number(skipNumberOfRecord) !== 0 &&
        Number(skipNumberOfRecord) >= count
      ) {
        toast.error("Skip Number of record should not be greater than or equal to the Total records.");
      } else if (
        Number(numberOfRecord) <= 0
      ) {
        toast.error("Number of record should be greater than 0.");
      } else if (
        Number(numberOfRecord) > count
      ) {
        toast.error("Number of record should not be greater than the Total records.");
      } else if (
        (Number(numberOfRecord) + Number(skipNumberOfRecord)) > count ||
        (Number(numberOfRecord) + Number(skipNumberOfRecord)) <= 0
      ) {
        toast.error("Invalid Total Number of records to export.");
      }
      // else if (
      //   !IS_VALID(password) ||
      //   !IS_VALID(password.trim())
      // ) {
      //     toast.error("Excel File Password is required.");
      // } 
      else {
        this.setState({
          isExportStarting: true
        });
  
        let params = {
            skipNumberOfRecord: parseInt(skipNumberOfRecord) || 0,
            numberOfRecord: parseInt(numberOfRecord)
          // password: password.trim()
        };

        axios.post(
          WEB_PATH + "/Kumulos/export",
          params,
          {
              timeout: 30000
          }
        )
        .then((res) => {
          let {
            fileName,
            socketNspId
          } = res.data;
  
          this.setState({
            isExportStarting: false,
            isExporting: true
          });
  
          let io = socketIOClient(
            WEB_PATH,
            {
                transports: ["websocket"],
                path: "/socket.io",
                query: {
                    nspId: socketNspId
                },
                secure: true
            }
          );
  
          let listenerName = "export-kumulos-socket";
  
          io.on(
            listenerName,
            (data) => {
                let {
                    status,
                    progress,
                    fileName,
                    message
                } = data;
                if (status === "PROGRESS") {
                    this.setState({
                        exportPercentage: progress
                    });
                } else if (status === "DONE") {
                    io.off(listenerName);
                    io.close();
                    
                    axios.get(
                      WEB_PATH + "/Kumulos/download/" + fileName,
                       {
                            responseType: "arraybuffer"
                        }
                    )
                    .then((res2) => {
                        let blob = new Blob([res2.data], { type: "application/vnd.ms-excel" }),
                            filename = `Kumulos ${moment().format("MMM DD YYYY hh:mm A")}.xlsx`;
        
                        this.setState({
                            isExporting: false,
                            isExportSuccess: true,
                            exportPercentage: 100,
                            fileConfig: {
                            filename: filename,
                            blob: blob
                            }
                        });
        
                        FileSaver.saveAs(blob, filename);
                    })
                    .catch((err) => {
                        let errorMessage = err.message;
        
                        if (
                            err.response &&
                            err.response.data &&
                            ("TextDecoder" in window)
                        ) {
                            let enc = new TextDecoder("utf-8");
                            let arr = new Uint8Array(err.response.data);
                            
                            let data = JSON.parse(enc.decode(arr)) || {};
        
                            if (
                                data.error &&
                                data.error.message
                            ) {
                                errorMessage = data.error.message;
                            }
                        }
                        
                        this.setState({
                            isExporting: false,
                            isExportError: true,
                            errorMessage
                        });
                    });
                } else if (status === "ERROR") {
                    io.off(listenerName);
                    io.close();
                    
                    this.setState({
                        isExporting: false,
                        isExportError: true,
                        errorMessage: message
                    });
                }
            }
          );
        })
        .catch((err) => {
          let errorMessage = err.message;
  
          if (
              err.response &&
              err.response.data &&
              typeof err.response.data === "string"
          ) {
              errorMessage = err.response.data;
          }
  
          this.setState({
              isExportStarting: false,
              isExportError: true,
              errorMessage
          });
        });
      }
    }
  
    downloadFile () {
      let {
          fileConfig
      } = this.state;
  
      let {
          filename,
          blob
      } = fileConfig
  
      if (IS_VALID(filename) && IS_VALID(blob)) {
          FileSaver.saveAs(blob, filename);
      }
    }
  
    isLoading () {
      let {
          isExportStarting,
          isExporting
      } = this.state;
  
      return isExportStarting || isExporting;
    }
  
    render () {
      let {
        password,
        skipNumberOfRecord,
        numberOfRecord,
  
        isExportStarting,
        isExporting,
        isExportSuccess,
        isExportError,
        exportPercentage,
        errorMessage
      } = this.state;
  
      let {
            count,
          closeModal
      } = this.props;
  
      return (
        <div>
          {
            !isExporting &&
            !isExportSuccess &&
            !isExportError ? (
              [
                <p>Exporting of Kumulos data may take some time depending on the number of records.</p>,
                <p>Total records: <b>{count}</b></p>,
                <Form>
                  <Row>
                    <Col
                        md={6}
                        mdOffset={3}
                    >
                    <FormGroup>
                      <ControlLabel>Number of records to skip</ControlLabel>
                        <FormControl
                            {...{
                                type: "number",
                                value: skipNumberOfRecord,
                                onChange: (e) => {
                                    this.setState({
                                        skipNumberOfRecord: e.target.value.replace(/[^0-9.]/g, "")
                                    });
                                }
                            }}
                        />
                    </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                        md={6}
                        mdOffset={3}
                    >
                    <FormGroup>
                      <ControlLabel>Number of records to export</ControlLabel>
                        <FormControl
                            {...{
                                type: "number",
                                value: numberOfRecord,
                                onChange: (e) => {
                                    this.setState({
                                        numberOfRecord: e.target.value.replace(/[^0-9.]/g, "")
                                    });
                                }
                            }}
                        />
                    </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                        md={6}
                        mdOffset={3}
                    >
                    <FormGroup>
                      <ControlLabel>Sum</ControlLabel>
                        <FormControl
                            readOnly
                            {...{
                                type: "number",
                                value: Number(numberOfRecord) + Number(skipNumberOfRecord)
                            }}
                        />
                    </FormGroup>
                    </Col>
                  </Row>
                </Form>,
                // <br/>,
                // <p>Note: The export files will be password protected with the recommended password below. </p>,
                // <Form inline>
                //  <FormGroup>
                //     <ControlLabel>Recommended Password<span style={{ color: "red" }}>*</span>:&nbsp;</ControlLabel>
                //     <FormControl
                //       disabled={isExportStarting}
                //       value={password}
                //       onChange={(e) => {
                //         if (!isExportStarting) {
                //             this.setState({ password: e.target.value });
                //         }
                //       }}
                //     />
                //   </FormGroup>
                // </Form>,
                <br/>,
                <br/>,
                <div style={{ textAlign: "center" }}>
                  <Button  
                    className="btn-primary"
                    disabled={isExportStarting}
                    onClick={() => {
                      this.exportData()
                    }}>
                    {isExportStarting ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }} /> </span> : ""}  EXPORT
                    </Button>
                </div>
              ]
            ) : (
              ""
            )
          }
          {
            isExporting ? (
              [
                <p>This may take some time depending on the number of records.</p>,
                <ProgressBar
                  active
                  striped
                  bsStyle="success"
                  now={exportPercentage}
                  label={`${exportPercentage}%`}
                />
              ]
            ) : isExportSuccess || isExportError ? (
              isExportSuccess ? (
                <div style={{ textAlign: "center" }}>
                    <Button
                        bsStyle="success"
                        content="DOWNLOAD FILE"
                        onClick={this.downloadFile}
                    >
                        DOWNLOAD FILE
                    </Button>
                </div>
              ) : (
                [
                  <h3 style={{ textAlign: "center", color: "red" }}>Something went wrong.</h3>,
                  <h4 style={{ textAlign: "center"}}>{errorMessage}</h4>,
                  <div style={{ textAlign: "center" }}>
                    <Button
                      bsStyle="primary"
                      onClick={() => {
                        closeModal();
                      }}>
                      CLOSE
                    </Button>
                  </div>
                ]
              )
            ) : (
              ""
            )
          }
        </div>
      );
    }
    
    componentDidMount () {
      this.setState({
          password: GENERATE_RANDOM(10, "string")
      });
    }
  }

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
    SET_KUMULOS
}                           from "actions/const";

function mapStateToProps(state) {
	var {
		accessjson,
        Kumulos
	} = state;
	return {
		accessjson,
        Kumulos
	};
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: (keyValueObj, actioType = SET_KUMULOS) => generics.setValue(actioType, keyValueObj)
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Kumulos);


// WEBPACK FOOTER //
// ./components/Kumulos/index.js